export default "__VITE_ASSET__BNn2CG0F__"